module.exports = "<div class=\"cdna-help-center\">\r\n    <h2>Welcome to the Help Center</h2>\r\n    <div class=\"banner\">\r\n\r\n        <ul class=\"nav nav-pills\">\r\n        </ul>\r\n        <button class=\"btn glyphicons iphone\" data-role=\"contact\">\r\n            <i />\r\n            Contact Support\r\n        </button>\r\n        <button class=\"btn glyphicons print\" data-role=\"print\">\r\n            <i />\r\n            Print\r\n        </button>\r\n    </div>\r\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./client/helpCenterView.html
 ** module id = 15
 ** module chunks = 0
 **/